@import 'styles/mixins';
@import 'styles/variables';

.form {
  display: grid;
  grid-template-columns: 100px auto;
  grid-gap: 12px;

  .input {
    @include lg-regular;
    height: 44px;
    padding: 2px 12px;
    border-radius: 8px;

    &::placeholder {
      color: var(--neutral-30);
    }
  }
}

.footer {
  display: flex;
  justify-content: flex-end;
}

.label {
  @include lg-regular;
  padding-top: 12px;
  color: var(--neutral-40);
}

.checkboxLabel {
  @include lg-regular;
  color: var(--neutral-50);
  display: flex;
  gap: 6px;
  align-items: center;
}

.checkBoxField {
  display: flex;
  align-items: center;
}

.recipientsSelector {
  flex: 1;
  position: relative;
  width: 100%;

  input {
    @include lg-regular;
  }

  input#approvers,
  input#reviewers,
  input#viewers {
    &::placeholder {
      color: var(--neutral-30);
    }
  }
}

.recipientsSelectorField {
  @include transition;
  min-height: 48px;
  border: 1px solid var(--neutral-10);
  border-radius: 8px;
  display: flex;
  align-items: center;
  padding: 0 10px;

  &.focused {
    box-shadow: 0px 0px 0px 2px var(--focus-5);
    border-color: var(--focus-50);
  }
}

.message {
  @include transition;
  padding: 10px;
  @include lg-regular;
  flex-grow: 1;
  resize: none;
  min-height: 170px;
  border: 1px solid var(--neutral-10);
  border-radius: 8px;
  color: var(--neutral-90);

  &::placeholder {
    color: var(--neutral-30);
  }

  &:focus {
    box-shadow: 0px 0px 0px 2px var(--focus-5);
    border-color: var(--neutral-30);
  }
}

.dueDateInputsWrapper {
  display: flex;
  align-items: flex-start;
  padding-top: 2px;
  gap: 12px;
}

.customDueDateInput {
  position: relative;
  margin-top: 2px;

  &:after {
    content: 'days';
    position: absolute;
    color: var(--neutral-40);
    top: 10px;
  }

  &.oneChar:after {
    left: 32px;
  }

  &.twoChars:after {
    left: 43px;
  }

  &.threeChars:after {
    left: 54px;
  }
}
